import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class LayoutsService {
  private headerLayout = new Subject<string>();

  changeHeader(message: string) {
    this.headerLayout.next(message);
  }

  clearHeader() {
    this.headerLayout.next();
  }

  getHeader(): Observable<string> {
    return this.headerLayout.asObservable();
  }
}
